import { navigate } from 'gatsby';
import React from 'react';
import { ButtonStoryblok } from '../../../_shared/interfaces/storyblok';
import { StoryblokCommon } from '../../../lib/storyblok/storyblok';
import HsButton from './hs-button';

import * as StoryblokButtonStyles from './storyblok-button.module.scss';
import { getMultilinkURL } from '../../../lib/helpers/helpers';

const StoryblokButton = ({
    blok,
    storyblokCommon,
    size,
}: {
    blok: ButtonStoryblok;
    storyblokCommon: StoryblokCommon;
    size?: 'small' | 'standard' | 'large';
}) => {
    let onClick;
    if (blok.link && !blok.open_login) {
        const link = getMultilinkURL(blok.link) || blok.url;

        if (blok.link.linktype === 'story') {
            onClick = () => navigate(link);
        } else if (blok.link.linktype === 'url') {
            onClick = () => window.open(link);
        }
    }

    return (
        <div className={StoryblokButtonStyles.storyblokButton}>
            <HsButton
                storyblokCommon={storyblokCommon}
                openLogin={blok.open_login}
                onClick={onClick}
                appearance={blok.appearance}
                size={size ? size : 'standard'}
            >
                {blok.text}
            </HsButton>
        </div>
    );
};

export default StoryblokButton;
